import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreQuotationRevisionsModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { DirectQuoteButtonComponent } from './direct-quote-button.component';

@NgModule({
  declarations: [DirectQuoteButtonComponent],
  imports: [
    CommonModule,
    UiModule,
    TrackingModule,
    DatastoreQuotationRevisionsModule,
  ],
  exports: [DirectQuoteButtonComponent],
})
export class DirectQuoteButtonModule {}
